import { TextField } from '@fox/atoms/src/text-field/index';
import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { FormRenderMode } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../../form-runtime-context/form-runtime-context';
import { QuestionBlockMetadata } from '../contracts';
import { useMuiInputQuestionStyle } from './useMuiInputQuestionStyle';

type IRenderNumberQuestionProps = {
	inEditMode: boolean;
	questionName: string;
	id: string;
	placeholder?: string;
	maxValue?: QuestionBlockMetadata['maxValue'];
};

export const RenderNumberQuestion = (props: IRenderNumberQuestionProps) => {
	const { inEditMode, questionName, id } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();
	const sx = useMuiInputQuestionStyle(id);
	const answer = getAnswer(questionName)?.answer?.answerString;

	return inEditMode ? (
		<></>
	) : (
		<TextField
			size="small"
			type="number"
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) {
					return;
				}
				let value: string | undefined;
				if (strIsNullOrEmpty(e.target.value)) {
					value = undefined;
				} else {
					value = e.target.value;
				}
				if (props.maxValue && Number(value) > props.maxValue) {
					value = String(props.maxValue);
				}
				if (isNaN(Number(value))) value = undefined;
				answerQuestion({
					answer: {
						answerString: value
					},
					questionName: questionName
				});
			}}
			placeholder={props.placeholder}
			value={answer ?? ''}
			sx={sx}
		/>
	);
};
